import React, { Component } from "react";

import api, { apiCRMv3 } from "../../services/api";
import {
	login,
	isAuthenticated,
	setType,
	setBranches,
	loginCRMv3,
} from "../../services/auth";

export default class Login extends Component {
	constructor(props) {
		super(props);

		this.state = {
			login: false,
			error: null,
			cpf: "",
			password: "",
		};

		this.handleClickLogin = this.handleClickLogin.bind(this);

		if (isAuthenticated()) {
			this.props.history.push("/dashboard");
		}
	}

	handleClickLogin = async (e) => {
		e.preventDefault();

		console.log(this.state);

		this.setState((prevState) => ({
			...prevState,
			login: true,
		}));

		const { cpf, password } = this.state;

		if (!cpf || !password) {
			this.setState({
				error: "Preencha todos os dados para se cadastrar",
			});
			this.setState((prevState) => ({
				...prevState,
				login: false,
			}));
		} else {
			try {
				const returnToken = await api.post("/login", { cpf, password });
				const returnTokenCRMv3 = await apiCRMv3.post("/login-by-cpf", {
					cpf,
					password,
				});
				setType(returnToken.data.user_data.user_type);
				console.log(returnToken.data.user_data.branches);
				setBranches(returnToken.data.user_data.branches);
				login(returnToken.data.token, returnToken.data.user_data);
				loginCRMv3(returnTokenCRMv3.data.data.token);
				this.props.history.push("/dashboard");
			} catch (err) {
				console.log(err);
				this.setState({ error: "Ocorreu um erro ao fazer login." });

				this.setState((prevState) => ({
					...prevState,
					login: false,
				}));
			}
		}
	};

	render() {
		return (
			<React.Fragment>
				<div className="app-container app-login">
					<div className="flex-center">
						<div className="app-header"></div>
						<div className="app-body">
							<div
								className="loader-container text-center"
								style={{
									display: this.state.login
										? "block"
										: "none",
								}}
							>
								<div className="icon">
									<div className="sk-folding-cube">
										<div className="sk-cube1 sk-cube"></div>
										<div className="sk-cube2 sk-cube"></div>
										<div className="sk-cube4 sk-cube"></div>
										<div className="sk-cube3 sk-cube"></div>
									</div>
								</div>
								<div className="title">Fazendo login...</div>
							</div>
							<div
								className="app-block"
								style={{
									display: !this.state.login
										? "block"
										: "none",
								}}
							>
								<div className="app-form">
									<div className="form-header">
										<div className="app-brand">
											<span className="highlight">
												Cartão
											</span>{" "}
											Express
										</div>
									</div>
									{this.state.error && (
										<p>{this.state.error}</p>
									)}
									<form onSubmit={this.handleClickLogin}>
										<div className="input-group">
											<span
												className="input-group-addon"
												id="basic-addon1"
											>
												<i
													className="fa fa-user"
													aria-hidden="true"
												></i>
											</span>
											<input
												type="text"
												className="form-control"
												placeholder="CPF"
												aria-describedby="basic-addon1"
												onChange={(e) =>
													this.setState({
														cpf: e.target.value,
													})
												}
											/>
										</div>
										<div className="input-group">
											<span
												className="input-group-addon"
												id="basic-addon2"
											>
												<i
													className="fa fa-key"
													aria-hidden="true"
												></i>
											</span>
											<input
												type="password"
												className="form-control"
												placeholder="Senha"
												aria-describedby="basic-addon2"
												onChange={(e) =>
													this.setState({
														password:
															e.target.value,
													})
												}
											/>
										</div>
										<div className="text-center">
											<input
												type="submit"
												className="btn btn-success btn-submit"
												value="Entrar"
											/>
										</div>
									</form>
								</div>
							</div>
						</div>
						<div className="app-footer"></div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}
